<div class="account-under-review-container">
    <div class="account-under-review-page">
        <div class="account-under-review-modal-container">
            <div class="icon-container">
                <img src="assets/icons/icon-team-under-review.svg" alt="asc"/>
            </div>
            <div class="text-container">
                <div class="header">
                    Your account is under review
                </div>
                <div class="sub-header divider pl-20 pr-20">
                    <div>This may take up to 48 hours.</div>
                    <div>You'll be notified by email once the process is finished.</div>
                </div>
                <div class="footer-container">
                    <!-- <div class="footer pt-6">Please contact us at <span class="support-link"> support@c2keep.com </span> if you have any questions. </div> -->
                    <div class="footer pt-6">Please contact us at <a class="support-link" href="mailto:support@c2keep.com">support@c2keep.com</a>
                        if you have any questions. 
                    </div>
                    <div class="footer">Thank you for using C2Keep!</div>
                </div>
                <app-button
                    class="pt-10"
                    text="Return to Login"
                    icon="icon-arrow-left"
                    [minWidth]="164"
                    (clicked)="navigateToLoginPage()"
                >
                </app-button>
            </div>
          </div>          
    </div>
  </div>